import { createActions, createReducer } from 'reduxsauce'

import RecursosDestinacaoService from '../servicos/RecursosDestinacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaRecursosDestinacaoInicio: [],
    buscaRecursosDestinacaoSucesso: ['recursosDestinacao'],
    buscaRecursosDestinacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaRecursosDestinacao = () => {
    return dispatch => {
        dispatch(Creators.buscaRecursosDestinacaoInicio())
        let serv = new RecursosDestinacaoService()
        return serv
            .getRecursosDestinacao()
            .then(response => dispatch(Creators.buscaRecursosDestinacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaRecursosDestinacaoErro(error)))
    }
}

const buscaRecursosDestinacaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaRecursosDestinacaoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaRecursosDestinacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.recursosDestinacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_RECURSOS_DESTINACAO_INICIO]: buscaRecursosDestinacaoInicio,
    [Types.BUSCA_RECURSOS_DESTINACAO_ERRO]: buscaRecursosDestinacaoErro,
    [Types.BUSCA_RECURSOS_DESTINACAO_SUCESSO]: buscaRecursosDestinacaoSucesso,
})
